import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchProjectbetrokkenen,
  initialState,
} from '../services/fetchProjectbetrokkenen'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { useProjectbetrokkenenSearch, queryKey }

const queryKey = 'aanvraag-projectbetrokkenen'

const useProjectbetrokkenenSearch = ({
  externalFilters: filters,
}: {
  externalFilters: ContractinstellingenSearchFilters
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isFetching: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, filters],
    queryFn: () => fetchProjectbetrokkenen(filters),
    enabled: hasPermissions && !!filters.combi,
  })

  useQueryErrorAlert(
    error,
    errorUpdatedAt,
    'Fout bij ophalen van projectbetrokkenen',
  )

  return {
    data: data || initialState.data,
    isLoading,
    error,
  }
}
